/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AuditReportsAodNotificationSettingsSchema } from "./AuditReportsAodNotificationSettingsSchema";

export const AuditReportsAodRuleReportTypeEnum = {
    AUDIT_GIP_STATUS: "AUDIT_GIP_STATUS",
    AUDIT_GIP_ALTERNATIVE_REPORT: "AUDIT_GIP_ALTERNATIVE_REPORT",
    BCR_MATCHES: "BCR_MATCHES",
    LTX_MATCHES: "LTX_MATCHES",
    AUDIT_BROADCAST_EVIDENCE: "AUDIT_BROADCAST_EVIDENCE"
} as const;

export type AuditReportsAodRuleReportTypeEnumKey = (typeof AuditReportsAodRuleReportTypeEnum)[keyof typeof AuditReportsAodRuleReportTypeEnum];

export const AuditReportsAodRuleTriggerEnum = {
    ORDER_END: "ORDER_END",
    EOW_AND_ORDER_END: "EOW_AND_ORDER_END"
} as const;

export type AuditReportsAodRuleTriggerEnumKey = (typeof AuditReportsAodRuleTriggerEnum)[keyof typeof AuditReportsAodRuleTriggerEnum];

export type AuditReportsAodRule = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    reportType: AuditReportsAodRuleReportTypeEnumKey;
    /**
     * @type object
    */
    reportConfig: object;
    /**
     * @type object
    */
    exportOptions: object;
    /**
     * @type object
    */
    exportConditions: object;
    /**
     * @type string
    */
    trigger: AuditReportsAodRuleTriggerEnumKey;
    /**
     * @type object
    */
    notificationSettings: AuditReportsAodNotificationSettingsSchema;
    /**
     * @type string | undefined
    */
    createdById?: string;
    /**
     * @type boolean
    */
    active: boolean;
    /**
     * @type array
    */
    managers: {
        /**
         * @type string | undefined
        */
        userId?: string;
    }[];
    /**
     * @type string | undefined
    */
    lastProcessedRunId?: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
};